<template>
  <div class="rss-widget" :style="style">
    <RssViewer :setting="rssSetting" />
  </div>
</template>

<script>
  import RssViewer from '@/components/rssViewer/RssViewer.vue';

  import { simpleTypeMixin } from '@/helpers';
  import templateWidget from '@/components/templates/mixins/templateWidget';

  export default {
    name: 'RssWidget',

    mixins: [simpleTypeMixin, templateWidget],

    components: {
      RssViewer,
    },

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return {
          ...this.defaultStyling(this.widget),
          overflow: 'hidden',
        };
      },

      rssSetting() {
        return {
          rssLink: this.widget.object.link,
          rssTheme: this.widget.object.theme,
          rssDuration: this.widget.object.display.duration,
          display: this.widget.object.display,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .rss-widget {
    position: absolute;
    overflow: hidden;
  }
</style>
